import { useContext } from "react";
import { IdentityContext } from "./IdentityProvider.js";
const useIdentity = () => {
  const ctx = useContext(IdentityContext);
  if (!ctx) {
    throw new Error("Identity context is not initialized");
  }
  return ctx.identity;
};
export {
  useIdentity
};
//# sourceMappingURL=useIdentity.js.map
